import React from 'react';
import { InputNumber } from 'antd';

export default function BotRateLimitField({ value, onChange, disabled }) {
  return (
    <div className="bot-rate-limit-field">
      <InputNumber
        min={1}
        max={120}
        value={value ?? undefined}
        onChange={onChange}
        disabled={disabled}
        className="bot-rate-limit-input"
        placeholder="Unlimited"
      />
      <span className="bot-rate-limit-suffix">msg / min</span>
    </div>
  );
}
